<template>
  <q-btn-dropdown
    split
    :icon="isLinked ? 'refresh' : 'link_off'"
    label="Sync TMDB"
    outline
    :loading="syncingWithTmdb"
    @click="syncWithTmdb()"
  >
    <q-list>
      <q-item
        v-if="isLinked"
        v-close-popup
        class="bg-grey-1"
      >
        <q-item-section>
          <q-item-label overline>
            Synced Languages
          </q-item-label>
          <q-item-label caption>
            {{ syncedLanguages }}
          </q-item-label>
        </q-item-section>
      </q-item>
      <q-item
        v-close-popup
        clickable
        @click="syncWithTmdb(true)"
      >
        <q-item-section avatar>
          <q-avatar
            icon="refresh"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label>Sync with Override</q-item-label>
          <q-item-label caption>
            Sync and replace existing data with TMDB data.
          </q-item-label>
        </q-item-section>
      </q-item>
      <q-item
        v-close-popup
        clickable
        @click="setTmdbId()"
      >
        <q-item-section avatar>
          <q-avatar
            :icon="isLinked ? 'edit' : 'link'"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label>
            {{ isLinked ? 'Edit' : 'Set' }} the TMDB ID
            {{ isLinked ? `(Current: ${movie.tmdbId})` : '' }}
          </q-item-label>
          <q-item-label caption>
            Set the source TMDB Movie ID the data is synced from.
          </q-item-label>
        </q-item-section>
      </q-item>
      <q-item
        v-if="isLinked"
        v-close-popup
        clickable
        @click="unlinkFromTmdb()"
      >
        <q-item-section avatar>
          <q-avatar
            icon="link_off"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label>Unlink from TMDB</q-item-label>
          <q-item-label caption>
            Disable automatic TMDB data sync.
          </q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
    <q-tooltip v-if="isLinked && currentCircuit && currentCircuit.additionalLanguages.length > 0">
      *TMDB movie data for translated languages is not guaranteed to be complete or accurate.
    </q-tooltip>
  </q-btn-dropdown>
</template>

<script>
export default {
  name: 'TmdbSyncDropdown',
  props: {
    movie: {
      type: Object,
      required: true
    }
  },
  emits: ['sync'],
  data () {
    return {
      syncingWithTmdb: false
    }
  },
  configuration: ['currentCircuit'],
  computed: {
    isLinked () {
      return !!this.movie.tmdbId
    },
    syncedLanguages () {
      const languages = ['English (en)']
      if (_.includes(this.currentCircuit?.additionalLanguages, 'es')) {
        languages.push('Spanish (es-MX)*')
      }
      return languages.join(', ')
    }
  },
  methods: {
    async syncWithTmdb (override) {
      this.syncingWithTmdb = true
      await this.movie.syncWithTmdb(override)
      this.$emit('sync')
      this.syncingWithTmdb = false
    },
    async unlinkFromTmdb () {
      this.syncingWithTmdb = true
      this.movie.tmdbId = null
      await this.movie.save()
      this.syncingWithTmdb = false
    },
    setTmdbId () {
      this.$q.dialog({
        title: 'Set TheMovieDB ID for ' + this.movie.name,
        message: 'What is the ID of the movie on The Movie Database (TMDB)?',
        prompt: {
          model: this.movie.tmdbId,
          type: 'number' // optional
        }
      }).onOk(data => {
        this.movie.tmdbId = data
        this.movie.save()
      })
    }
  }
}
</script>
